// src/MyForm.tsx
import React, { useEffect, useState } from 'react';
import { TextField, Button, Box, FormLabel, MenuItem, IconButton, Tooltip } from '@material-ui/core';
import { FixtureListItem, LeagueListItem, RoundFixtureInput, RoundFixtureItem } from './CreateRoundModels';
import CreateRoundUtil from './CreateRoundUtil';
import FixtureChooserTable from './FixtureChooserTable';
import { FixtureFilter } from '../TeamOverview/TeamOverviewModels';
import ChooseLeagueDialog from '../RoundOverview/ChooseLeagueDialog';
import { ActionState } from '../FixtureOverview/FixtureOverviewModels';
import FixtureOverviewUtil from '../FixtureOverview/FixtureOverviewUtil';
import RoundOverviewUtil from '../RoundOverview/RoundOverviewUtil';
import { blue } from '@material-ui/core/colors';
//import RoundFixtureTable from './RoundFixtureTable';
//import {useForm} from 'react-hook-form'
// import SearchIcon from '@material-ui/icons/Search';
// import AddIcon from '@material-ui/icons/Add';

interface FixtureChooserState {
    // Define your form fields and their types here
    fromDate: string;
    fromTime: string;
    toDate: string;
    toTime: string;
    pageSize: string;
    fixtureId: string;
    fixtureName: string;
    leagueId: number;
    leagueName: string;
    league?: LeagueListItem;
}


interface FixtureChooserProps {
    maxFixtures: number;
    onAdd: (fixture: FixtureListItem) => void;
}

const FixtureChooser: React.FC<FixtureChooserProps> = (props) => {
    var defaultFromDate = CreateRoundUtil.addHours(new Date(), 1);
    var defaultToDate = CreateRoundUtil.addDays(defaultFromDate, 7);
    const [formState, setFormState] = useState<FixtureChooserState>({
        fromDate: CreateRoundUtil.getDateWithoutTimeString(defaultFromDate),
        fromTime: CreateRoundUtil.getTimeString(defaultFromDate),
        toDate: CreateRoundUtil.getDateWithoutTimeString(defaultToDate),
        toTime: CreateRoundUtil.getTimeString(defaultToDate),
        pageSize: "50",
        fixtureId: "",
        fixtureName: "",
        leagueId: 0,
        leagueName: "",
        league: undefined
    });

    const [fromDateError, setFromDateError] = useState<string>("");
    const [fromTimeError, setFromTimeError] = useState<string>("");
    const [toDateError, setToDateError] = useState<string>("");
    const [toTimeError, setToTimeError] = useState<string>("");
    const [pageSizeError, setPageSizeError] = useState<string>("");
    const [fixtureNameError, setFixtureNameError] = useState<string>("");
    const [fixtures, setFixtures] = useState<FixtureListItem[]>([]);
    const [actionState, setActionState] = useState<ActionState>(FixtureOverviewUtil.createEmptyActionState());

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        setFormState({ ...formState, [name]: value });
    };

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        // Add form submission logic here
        //console.log(formData);
        var fromDate = CreateRoundUtil.parseDateX(formState.fromDate);
        var toDate = CreateRoundUtil.parseDateX(formState.toDate);
        var from = fromDate;
        var to = toDate;
        var pageSize = parseInt(formState.pageSize);

        var valid = true;
        var fromDateErr = "";
        var fromTimeErr = "";
        var toDateErr = "";
        var toTimeErr = "";
        var pageSizeErr = "";
        // const leagueFormatPattern = /(?<name>[\w\d\s]+)\s+\((?<location>[\w\d\s]+)\)$/;
        if (formState.fromTime.length > 0) {
            if (CreateRoundUtil.isValidTime(formState.fromTime)) {
                from = CreateRoundUtil.addTime(from, formState.fromTime);
            }
            else {
                valid = false;
                fromTimeErr = "Invalid time (HH:mm)";
            }
        }
        if (formState.toTime.length > 0) {
            if (CreateRoundUtil.isValidTime(formState.toTime)) {
                to = CreateRoundUtil.addTime(to, formState.toTime);
            }
            else {
                valid = false;
                toTimeErr = "Invalid time (HH:mm)";
            }
        }
        if (isNaN(pageSize)) {
            valid = false;
            pageSizeErr = "Invalid int";
        }
        if (fromDate > toDate) {
            valid = false;
            toDateErr = "To date is less than From date";
        } else if (from > to) {
            valid = false;
            toDateErr = "To datetime is less than From datetime";
        } else if (from === to) {
            if (formState.toTime.length === 0) {
                to = CreateRoundUtil.addDays(toDate, 1);
            } else if (toDateErr.length === 0 && toTimeErr.length === 0) {
                valid = false;
                toDateErr = "To datetime is equal From datetime";
            }
        }

        setFromDateError(fromDateErr);
        setFromTimeError(fromTimeErr);
        setToDateError(toDateErr);
        setToTimeError(toTimeErr);
        setPageSizeError(pageSizeErr);

        if (!valid) {
            return;
        }

        var done = false;
        var ast = FixtureOverviewUtil.createEmptyActionState();
        setActionState(FixtureOverviewUtil.createActionState(true, false, "SearchFixtures..."));
        var fixturePattern = formState.fixtureName.length === 0 ? undefined : formState.fixtureName;
        var filter: FixtureFilter = {
            status: RoundOverviewUtil.PENDING_STATUS,
            leagueId: formState.leagueId === 0 ? undefined : formState.leagueId,
            searchPattern: fixturePattern
        };
        FixtureOverviewUtil.getFixtures(pageSize, from, to, 0, filter).then((resp) => {
            done = true;
            if (!resp.success) {
                ast.error = true;
                ast.message = resp.message;
                setFixtures([]);
                return;
            }
            var fixtures1 = resp.item?.items;
            setFixtures(fixtures1 ? CreateRoundUtil.toFixtureListItems(fixtures1) : []);
        }).catch( error => {
            done = true;
            ast.error = true;
            ast.message = CreateRoundUtil.getExceptionMessage(error, false, `SearchFixtures error: ${error.message}`);
        }).finally( () => {
            if (done) {
                setActionState(ast);
            }
        });
    };
    const onAdd = (item: FixtureListItem) => {
        if (props.onAdd) {
            props.onAdd(item);
        }
    };
    const onCloseLeagueDlg = (league?: LeagueListItem) => {
        if (!league) {
            return;
        }
        var fs = { ...formState, leagueId: parseInt(league.id) };
        fs.leagueName = league.title;
        fs.league = league;
        setFormState(fs);
    };
    const onClearLeague = () => {
        if (formState.leagueId === 0) {
            return;
        }
        var fs = { ...formState, leagueId: 0 };
        fs.leagueName = "";
        fs.league = undefined;
        setFormState(fs);
    };
    var currentFixture = fixtures.find(f => f.id === formState.fixtureId);
    var actionBox = null;
    if ((actionState.executing || actionState.error) && actionState.message.length > 0) {
        actionBox = (
            <Box color={actionState.error ? RoundOverviewUtil.INVALID_COLOR : blue[500]} fontSize={12}>
                {actionState.message}
            </Box>
        );
    }

    return (
        <div>
            <form onSubmit={handleSubmit}>
                <Box>
                    <TextField
                        type="date"
                        name="fromDate"
                        label="From date"
                        value={formState.fromDate}
                        error={fromDateError && fromDateError.length > 0 ? true : false}
                        helperText={fromDateError}
                        onChange={handleChange}
                    />
                    <FormLabel style={{ padding: 2 }}> </FormLabel>
                    <TextField
                        name="fromTime"
                        label={CreateRoundUtil.timeInfoText}
                        value={formState.fromTime}
                        style={{ width: 50 }}
                        error={fromTimeError && fromTimeError.length ? true : false}
                        helperText={fromTimeError}
                        onChange={handleChange}
                    />
                    <span style={{ paddingLeft: 10, paddingRight: 20, textAlign: "center", verticalAlign: "center" }}></span>
                    <TextField
                        type="date"
                        name="toDate"
                        label="To date"
                        value={formState.toDate} error={toDateError && toDateError.length ? true : false}
                        helperText={toDateError}
                        onChange={handleChange}
                    />
                    <FormLabel style={{ padding: 2 }}> </FormLabel>
                    <TextField
                        name="toTime"
                        label={CreateRoundUtil.timeInfoText}
                        value={formState.toTime}
                        style={{ width: 50 }}
                        error={toTimeError && toTimeError.length ? true : false}
                        helperText={toTimeError}
                        onChange={handleChange} />
                </Box>
                <Box paddingTop={1} display="flex" alignItems="center">
                    <TextField
                        name="leagueName"
                        value={formState.leagueName}
                        label="League"
                        InputLabelProps={{shrink: true}}
                        InputProps={{ readOnly: true }}
                        style={{minWidth:350, marginLeft:5}}
                    />
                    <span style={{ padding: 2 }}></span>
                    <ChooseLeagueDialog open={false} openLabel="Change" onClose={onCloseLeagueDlg} disabled={actionState.executing} />
                    <Button 
                            variant="outlined"
                            color="secondary"
                            size="small"
                            style={{ marginLeft:5, marginRight:5 }}
                            onClick={e => onClearLeague()}
                            disabled={actionState.executing || !formState.leagueId}>
                            Clear
                    </Button>
                </Box>
                <Box paddingTop={1} display="flex" alignItems="center">
                    <TextField
                        name="fixtureName"
                        label="Fixture name"
                        value={formState.fixtureName}
                        error={fixtureNameError && fixtureNameError.length > 0 ? true : false}
                        helperText={fixtureNameError && fixtureNameError.length > 0 ? fixtureNameError : "Character sequence of Fixture name"}
                        onChange={handleChange}
                    />
                </Box>
                <Box paddingTop={1} display="flex" alignItems="center">
                    <TextField
                        name="pageSize" label="Page size" type="number" value={formState.pageSize} style={{ width: 100 }} error={pageSizeError && pageSizeError.length ? true : false} helperText={pageSizeError} onChange={handleChange} />
                    <FormLabel style={{ padding: 2 }}> </FormLabel>
                    <FormLabel style={{ padding: 2 }}> </FormLabel>
                    <Button variant="contained" color="secondary" type="submit" size="small" disabled={actionState.executing}>
                        Search
                    </Button>
                 </Box>
            </form>
            {actionBox}
            <Box paddingTop={2} />
            <FixtureChooserTable fixtures={fixtures} onAdd={onAdd} />
        </div>

    );
};

export default FixtureChooser;
